import * as React from 'react';
import { PickerTimeProps, RangePickerTimeProps } from 'antd/es/date-picker/generatePicker';
import { Dayjs } from 'dayjs';
import DatePicker from './DatePicker';

type TimeRangePickerProps = Omit<RangePickerTimeProps<Dayjs>, 'picker'>;

export interface TimePickerProps extends Omit<PickerTimeProps<Dayjs>, 'picker'> {}

const TimePicker = React.forwardRef<any, TimePickerProps>((props, ref) => {
	return <DatePicker {...props} picker="time" mode={undefined} ref={ref} />;
});

const RangePicker = React.forwardRef<any, TimeRangePickerProps>((props, ref) => {
	return <DatePicker.RangePicker {...props} picker="time" mode={undefined} ref={ref} />;
});

TimePicker.displayName = 'TimePicker';
(TimePicker as any).RangePicker = RangePicker;

export default TimePicker as typeof TimePicker & { RangePicker: typeof RangePicker };
